import { render } from "./BaseAnchorTag.vue?vue&type=template&id=ebf037a4&scoped=true"
import script from "./BaseAnchorTag.vue?vue&type=script&lang=js"
export * from "./BaseAnchorTag.vue?vue&type=script&lang=js"

import "./BaseAnchorTag.vue?vue&type=style&index=0&id=ebf037a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf037a4"]])

export default __exports__